export default "__VITE_ASSET__d831cb49__"